"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import { useEffect } from "react";
import {
	hideGleapChat,
	initializeGleap,
	setGleapSoundEnabled,
	showGleapChat,
} from "./utils";

interface GleapProviderProps {
	children: ReactNode;
	apiKey?: string;
	env?: string;
}

export function GleapProvider({ children, apiKey, env }: GleapProviderProps) {
	const pathname = usePathname();

	useEffect(() => {
		initializeGleap(apiKey, env);
		setGleapSoundEnabled(false);
	}, [apiKey, env]);

	useEffect(() => {
		const shouldShowGleap = [
			"/about",
			"/pricing",
			"/signin",
			"/signup",
			"/getting-started",
			"/problem",
			"/will-be-back-soon",
			"/feedback",
			"/queue",
		].some((path) => pathname.startsWith(path));

		if (pathname === "/" || shouldShowGleap) {
			showGleapChat();
		} else {
			hideGleapChat();
		}
	}, [pathname]);

	return <>{children}</>;
}
